module.exports = __webpack_public_path__ + "img/Weapon_18.1f8600e9.png";